module.exports = "<p>multiselect-v2 works!</p>\n"